<div
    class="row-container"
    [ngbPopover]="tooltipTemplate"
    [openDelay]="300"
    [closeDelay]="300"
    triggers="mouseenter:mouseleave"
    container="body"
    popoverClass="rask-icon-popover"
>
    <i class="fal fa-sm fa-handshake icon" aria-hidden="true"></i>
    <span class="w-100 plFix">{{input.naturalKey}} - {{input.title}}</span>
    <br />
    <span class="float-start left-margin w45">{{input.metadata["avtalsnummer"]}}</span>
    <span class="float-end w45 text-end">{{input.metadata["kontaktperson"]}}</span>
    <br />
    <span class="float-start left-margin w45">{{getAffarsformShort()}}</span>
    <span class="float-end w45 text-end">{{input.metadata["typ"]}}</span>
</div>
